var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Container"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4.58333,
    fill: "#AEC2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M14.3027 5.50098C14.9403 5.50098 15.4577 6.01679 15.458 6.6543V13.8457C15.458 14.0366 15.6128 14.1914 15.8037 14.1914C16.4414 14.1915 16.958 14.708 16.958 15.3457C16.9577 15.9832 16.4412 16.4999 15.8037 16.5H14.3203C14.3148 16.5001 14.3093 16.501 14.3037 16.501C14.2983 16.501 14.2925 16.5001 14.2871 16.5H6.6543C6.0169 16.4998 5.50026 15.9831 5.5 15.3457C5.5 14.7081 6.01674 14.1916 6.6543 14.1914C6.84468 14.1914 6.99902 14.0371 6.99902 13.8467V11.3994C6.99902 10.7617 7.51559 10.2451 8.15332 10.2451C8.77104 10.2451 9.27367 10.7299 9.30469 11.3398V14.6426C9.30479 14.8551 9.47694 15.0273 9.68945 15.0273C9.90197 15.0273 10.0741 14.8551 10.0742 14.6426V13.8164C10.0743 13.8135 10.0752 13.8106 10.0752 13.8076V9.0752C10.0753 8.43754 10.5918 7.9209 11.2295 7.9209C11.867 7.92107 12.3837 8.43765 12.3838 9.0752V10.665C12.3829 10.6754 12.3809 10.6857 12.3809 10.6963V14.6426C12.381 14.8551 12.5531 15.0273 12.7656 15.0273C12.978 15.0272 13.1503 14.855 13.1504 14.6426V10.6963C13.1504 10.693 13.1495 10.6898 13.1494 10.6865V6.65527C13.1494 6.01771 13.6652 5.50124 14.3027 5.50098Z",
    fill: "#1F0713"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCheckIcon);
export default __webpack_public_path__ + "static/media/credit-check-icon.3b83ff5a24a916a6981b76c5a62bd10b.svg";
export { ForwardRef as ReactComponent };